export const formattedDate = (inputDateString: any) => {
  if (inputDateString) {
    const year = inputDateString.substring(0, 4);
    const month = inputDateString.substring(4, 6);
    const day = inputDateString.substring(6, 8);
    return `${year}-${month}-${day}`;
  }
};
export const formattedDateDocument = (inputDate: any) => {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year} -${month}-${day}`;
};

export const subString = (sub: string) => {
  if (sub.length > 200) {
    return sub.substring(0, 200).concat('...');
  } else {
    return sub;
  }
};

export const formatParam = (param: []) => {
  if (!Array.isArray(param)) {
    throw new Error('Input param must be an array');
  }
  if (param.length === 0) {
    return '';
  }
  if (param.length > 0) {
    return param.reduce((formatted, keyword, index) => {
      formatted += `(${keyword})`;
      if (index !== param.length - 1) {
        formatted += ' and ';
      }
      return formatted;
    }, '');
  }
};
